import cleanFieldLabel from './cleanFieldLabel';
import getFieldLabel from './getFieldLabel';

/**
 * Returns a map of form field text to it's related error.
 *
 * @param $elements array of failed validation elements. Element are those using jquery validation library.
 * @returns map of form field text and related errors.
 */
const getInvalidFields = ($elements) => {
	const invalidFields = {};

	$elements.each((_index, element) => {
		const $element = $(element);
		const $errors = $element.next('.errors');
		const text = cleanFieldLabel(getFieldLabel(element));
		const isInvalid = $element.hasClass('invalid');

		if (isInvalid) {
			if ($errors.length > 0) {
				invalidFields[text] = $errors.text();
			} else if (element.validationMessage) {
				invalidFields[text] = element.validationMessage;
			}
		}
	});

	return invalidFields;
};

export default getInvalidFields;
